// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"45":"87d3b32d91cadaef","91":"495a020382724eb0"}[chunkId] + ".js";
};